import React from "react";
import { Grid, Divider } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
} from "App/Component/ui";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { RESET_STATE_FORM_FILTER, statusTransaksi } from "./helpers";
import DatePicker from "react-datepicker";
import moment from "moment";
export default function FormFilterDaftarPO({
  formFilter,
  setFormFilter,
  setNewData,
  typeButton = "submit",
  disabledStatus = false,
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  // const gudangUtama = useSelectOption(
  //   true,
  //   "/wmslogistik/gudang/gudangutama",
  //   TYPE_INSTANCE4,
  // );

  const unit = useSelectOption(
    true,
    "/wmsmaster/unit/read_gudang_farmasi",
    TYPE_INSTANCE4
  );

  const supplier = useSelectOption(
    true,
    "/wmsMasterAsset/master/list-supplier",
    TYPE_INSTANCE4,
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              name='id'
              label='ID PEMBELIAN'
              id='id'
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder='ID Pembelian'
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='nomorPO'
              label='NOMOR PO'
              id='nomorPO'
              value={formFilter.nomorPO}
              onChange={handleChange("nomorPO")}
              placeholder='Nomor PO'
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='statusTransaksi'
              label='STATUS TRANSAKSI'
              id='statusTransaksi'
              withSearch={true}
              disabled={disabledStatus}
              data={statusTransaksi}
              value={formFilter.status_transaksi}
              labelValue={formFilter.status_name}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  status_transaksi: e?.value,
                  status_name: e?.label,
                })
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='unit_id'
              label='UNIT'
              id='unit_id'
              withSearch={true}
              data={unit}
              value={formFilter.unit_id}
              labelValue={formFilter.unit}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  unit_id: e?.value,
                  unit: e?.label,
                })
              }
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name='supplier_id'
              label='SUPPLIER'
              id='supplier_id'
              withSearch={true}
              data={supplier}
              value={formFilter.supplier_id}
              labelValue={formFilter.supplier}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  supplier_id: e?.value,
                  supplier: e?.label,
                })
              }
            />
          </Grid>
          <Grid item sm={4}>
            <label htmlFor='date' className='form-control-label'>
              TANGGAL AWAL
            </label>

            <DatePicker
              id='date'
              autoComplete='off'
              className='form-control text'
              dateFormat='dd/MM/yyyy'
              timeIntervals={5}
              locale='id-ID'
              selected={moment(formFilter.tglAwal).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                });
              }}
              placeholderText='Tanggal'
            />
          </Grid>
          <Grid item sm={4}>


            <label htmlFor='date' className='form-control-label'>
              TANGGAL AKHIR
            </label>

            <DatePicker
              id='date'
              autoComplete='off'
              className='form-control text'
              dateFormat='dd/MM/yyyy'
              timeIntervals={5}
              locale='id-ID'
              selected={moment(formFilter.tglAkhir).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                });
              }}
              placeholderText='Tanggal'
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            onClick={handleSubmit}
            type={typeButton}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  );
}
